export default "__VITE_ASSET__Ckotfese__"